import Repository from './Repository'

const resource = 'horse-shoes'

export default {
  createHorseshoe (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateHorseshoe (tenantId, horseshoeId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${horseshoeId}`, data)
  },
  deleteHorseshoe (tenantId, horseshoeId) {
    return Repository.delete(`tenants/${tenantId}/${resource}/${horseshoeId}`)
  }
}
